import { render, staticRenderFns } from "./fileBox.vue?vue&type=template&id=113dd23d&scoped=true"
import script from "./fileBox.vue?vue&type=script&lang=js"
export * from "./fileBox.vue?vue&type=script&lang=js"
import style0 from "./fileBox.vue?vue&type=style&index=0&id=113dd23d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113dd23d",
  null
  
)

export default component.exports